import React from 'react';
import Skeleton from 'components/Skeleton';

const ReportTableSkeleton: React.FC = () => {
  return <Skeleton height="17.8em" variant="rect" />;
};

export default ReportTableSkeleton;
